// Routes redesigned in the join group. Each entry: { path, element }.
// Entries here override the legacy routes in App.jsx for the same path.
import GetInvolvedPage from "./GetInvolvedPage.jsx";
import ForStudentsPage from "./ForStudentsPage.jsx";
import ForSchoolsPage from "./ForSchoolsPage.jsx";
import ForPartnersPage from "./ForPartnersPage.jsx";
import OpportunitiesPage from "./OpportunitiesPage.jsx";
import OrganisationsPage from "./OrganisationsPage.jsx";
import JoinTeamPage from "./JoinTeamPage.jsx";
import InternshipsPage from "./InternshipsPage.jsx";
import OpportunityCategoryPage from "./OpportunityCategoryPage.jsx";
import ContactPage from "./ContactPage.jsx";
import LegalPage from "./LegalPage.jsx";
import NotFoundPage from "./NotFoundPage.jsx";

export const routes = [
  { path: "/get-involved", element: <GetInvolvedPage /> },
  { path: "/for-students", element: <ForStudentsPage /> },
  { path: "/for-schools", element: <ForSchoolsPage /> },
  { path: "/for-partners", element: <ForPartnersPage /> },
  { path: "/student-opportunities", element: <OpportunitiesPage /> },
  { path: "/student-opportunities/organisations", element: <OrganisationsPage /> },
  { path: "/student-opportunities/team", element: <JoinTeamPage /> },
  { path: "/student-opportunities/internships", element: <InternshipsPage /> },
  { path: "/student-opportunities/:category", element: <OpportunityCategoryPage /> },
  { path: "/contact", element: <ContactPage /> },
  { path: "/privacy", element: <LegalPage key="privacy" kind="privacy" /> },
  { path: "/terms", element: <LegalPage key="terms" kind="terms" /> },
  { path: "*", element: <NotFoundPage /> },
];
